import { createAxios } from '../auth'
import { IRIS_BASE_URL } from '.'

// The last FCM device token the shell registered. Retained so logout can unregister it: the token
// comes from the native shell over the WebView bridge, and the web app doesn't otherwise persist it.
let lastFcmToken: string | null = null
export const setLastFcmToken = (token: string) => { lastFcmToken = token }
export const getLastFcmToken = (): string | null => lastFcmToken

/**
 * Register an FCM device token with iris-server so the backend can push incoming-call
 * notifications to this device (Phase B of the mobile push work). Keyed server-side by the
 * authenticated user. The token is produced by the native shell (React Native) and handed to the
 * web app over the WebView bridge — the web app makes this authenticated call because it holds the
 * Keycloak JWT (the native shell does not).
 */
export async function registerFcmToken(authToken: string, fcmToken: string, platform = 'android'): Promise<void> {
  await createAxios(authToken).post(`${IRIS_BASE_URL}/fcm/token`, { token: fcmToken, platform })
}

/** Unregister a device token (e.g. on logout). Best-effort. */
export async function unregisterFcmToken(authToken: string, fcmToken: string): Promise<void> {
  await createAxios(authToken).delete(`${IRIS_BASE_URL}/fcm/token/${encodeURIComponent(fcmToken)}`)
}
